import { useCallback, useState } from "react";

import { supabasePublic } from "../lib/supabasePublic";
import { AppLayout } from "../components/AppLayout";
import { ForgotPasswordForm } from "ui/dist/forms/ForgotPasswordForm";
import { forgotPasswordSchema } from "validation/dist/forgotPassword";

const defaultValues = {
    email: "",
};
function ForgotPasswordPage() {
    const [submissionSuccess, setSubmissionSuccess] = useState("");

    const handleOnSubmit = useCallback(async ({ values, isValid, errors }) => {
        setSubmissionSuccess("");
        if (isValid) {
            await supabasePublic.auth.api.resetPasswordForEmail(values.email);
            setSubmissionSuccess(
                "Check your emails for a link to reset your password"
            );
        }
    }, []);

    return (
        <ForgotPasswordForm
            defaultValues={defaultValues}
            validationSchema={forgotPasswordSchema}
            onSubmit={handleOnSubmit}
            submissionSuccess={submissionSuccess}
        />
    );
}

// eslint-disable-next-line react/display-name
ForgotPasswordPage.getLayout = (page: React.ReactNode) => (
    <AppLayout title="Password Reset" contained>
        {page}
    </AppLayout>
);

export default ForgotPasswordPage;
